import styled from 'styled-components/macro'
import { Z_INDEX } from '../../../styles/z-index'

export const TopBarTitle = styled.div`
  font-weight: 600;
  font-size: 24px;
  line-height: 24px;
  color: #ffffff;
  margin-right: 16px;
`
export const Wrapper = styled.div`
  background: #054628;
  min-height: var(--footer-height);
  height: var(--footer-height);
`

export const MobileWrapper = styled.div`
  background: #fafafa;
  box-shadow: 0px 6px 58px 0px #6e6e6e33;
  position: fixed;
  bottom: env(safe-area-inset-bottom, 0); /* Position AT the safe area */
  left: 0;
  right: 0;
  z-index: ${Z_INDEX.MOBILE_FOOTER}; /* Above filter/sort overlays (910) */
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
`

export const MobileContent = styled.div`
  color: #054628;
  display: flex;
  align-items: center;
  padding: 0 32px;
  height: 60px; /* Fixed content height */
  justify-content: space-between;
`

export const Content = styled.div`
  color: white;
  display: flex;
  align-items: center;
  padding: 0 56px;
  height: 100%;
  @media (max-width: 600px) {
    padding: 0 16px;
    justify-content: center;
  }
`

export const FooterMenu = styled.div`
  margin-left: auto;

  a {
    font-size: 14px;
  }

  a:hover {
    background: #04331d;
  }

  a:last-child {
    @media (max-width: 600px) {
      display: none;
    }
  }
`
